export default "__VITE_ASSET__DPmoWuGq__"